import classNames from 'classnames';
import React from 'react';
import text, { formatCurrency } from '../../../text';
import List from '../../list/List';
import useData from './useData';
var MemberDiscounts = function() {
    var _orderTotals_price, _orderTotals_price1;
    var _useData = useData(), isEssentialUser = _useData.isEssentialUser, orderTotals = _useData.orderTotals, discounts = _useData.discounts, memberPrice = _useData.memberPrice, currency = _useData.currency, gstPercentage = _useData.gstPercentage;
    return /*#__PURE__*/ React.createElement(List, {
        isPaddingless: true,
        className: "is-borderless mt-2"
    }, /*#__PURE__*/ React.createElement("tbody", null, (orderTotals === null || orderTotals === void 0 ? void 0 : (_orderTotals_price = orderTotals.price) === null || _orderTotals_price === void 0 ? void 0 : _orderTotals_price.member_automatic_discount_total) > 0 ? /*#__PURE__*/ React.createElement(List.Item, {
        isSecondaryHighlight: true,
        className: classNames({
            pink: !isEssentialUser,
            grey: isEssentialUser
        }),
        description: text('dataInTheDatabaseDiscount', {
            discount: 30
        }),
        value: "-".concat(formatCurrency((orderTotals === null || orderTotals === void 0 ? void 0 : (_orderTotals_price1 = orderTotals.price) === null || _orderTotals_price1 === void 0 ? void 0 : _orderTotals_price1.member_automatic_discount_total) * gstPercentage, currency.name, currency.scale_factor, {}, true))
    }) : null, discounts.members.captureServicesDiscount > 0 ? /*#__PURE__*/ React.createElement(List.Item, {
        isSecondaryHighlight: true,
        className: classNames({
            pink: !isEssentialUser,
            grey: isEssentialUser
        }),
        description: text('captureServicesDiscount', {
            discount: 10
        }),
        value: "-".concat(formatCurrency(discounts.members.captureServicesDiscount * gstPercentage, currency.name, currency.scale_factor, {}, true))
    }) : null, discounts.members.addOnsDiscount > 0 ? /*#__PURE__*/ React.createElement(List.Item, {
        isSecondaryHighlight: true,
        className: classNames({
            pink: !isEssentialUser,
            grey: isEssentialUser
        }),
        description: text('addOnsDiscount', {
            discount: 10
        }),
        value: "-".concat(formatCurrency(discounts.members.addOnsDiscount * gstPercentage, currency.name, currency.scale_factor, {}, true))
    }) : null, !isEssentialUser && /*#__PURE__*/ React.createElement(List.Item, {
        isSecondaryHighlight: true,
        className: "pink font-weight-bold",
        description: "".concat(text('memberPriceIncGst')),
        value: formatCurrency(memberPrice, currency.name, currency.scale_factor, {}, true)
    })));
};
export default MemberDiscounts;
